module.exports = __webpack_public_path__ + "img/c05_unittechdecurionchampion_Normal_ua.d10769f6.webp";